import { takeLatest } from 'redux-saga/effects';

import { fetchExceptionsRoutine } from '../routines';
import { fetchColSaga } from './helper';

function* watchFetchExceptionsSaga() {
  yield takeLatest(fetchExceptionsRoutine.TRIGGER, fetchColSaga(fetchExceptionsRoutine, (payload) => `jobs/${payload.jobId}/exceptions`));
}

export {
  watchFetchExceptionsSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/exceptions.js